import './NewPoll.sass';

import { FC, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  BottomBar,
  Button,
  Form,
  FormItem,
  Header,
  Input,
  List,
  ListItem,
  ScrollView,
} from '$uikit';
import { IcClose16, IcPlusCircle28 } from '$assets';
import { toastActions } from '$store/toast';
import { Api } from '$api';
import { attachActions } from '$store/attach';
import { goBack } from '$navigation/helper';
import { useCurrentUserInfo, useTranslator } from '$hooks';

export const NewPoll: FC = () => {
  const dispatch = useDispatch();
  const [title, setTitle] = useState('');
  const [options, setOptions] = useState(['', '']);
  const [isAnonymous, setAnonymous] = useState(true);
  const [allowMultiple, setAllowMultiple] = useState(false);
  const user = useCurrentUserInfo();
  const t = useTranslator();

  const handleChange = useCallback(
    (index: number) => (event) => {
      setOptions((old) => {
        const newOptions = [...old];
        newOptions[index] = event.target.value;
        return newOptions;
      });
    },
    [],
  );

  const handleRemove = useCallback(
    (index: number) => () => {
      setOptions((old) => {
        const newOptions = [...old];
        newOptions.splice(index, 1);
        return newOptions;
      });
    },
    [],
  );

  const handleAddOption = useCallback(() => {
    setOptions((old) => [...old, '']);
  }, []);

  const handleSave = useCallback(() => {
    dispatch(toastActions.setToastLoading());
    Api.post('/poll/create', {
      title,
      options: options.filter((option) => !!(option || '').trim()),
      anonymous: isAnonymous,
      multipleAnswer: allowMultiple,
      correctAnswer: 0,
    })
      .then((resp) => {
        dispatch(toastActions.hideToast());
        const data: any = resp;
        dispatch(
          attachActions.addPoll({
            pickerId: `post_${user.id}`,
            pollId: data.pollId,
          }),
        );
        goBack();
      })
      .catch((e) => {
        dispatch(toastActions.setToastFail(e.message));
      });
  }, [title, options, isAnonymous, allowMultiple, user]);

  return (
    <>
      <Header showCloseButton backButtonOnClick={() => goBack()}>
        {t('poll_title')}
      </Header>
      <ScrollView>
        <Form>
          <FormItem title={t('new_poll_question_title')}>
            <Input value={title} onChange={(e) => setTitle(e.target.value)} />
          </FormItem>
          <FormItem title={t('new_poll_options_title')}>
            <div className="NewPoll__options">
              {options.map((option, index) => (
                <div className="NewPoll__option" key={index}>
                  <Input
                    placeholder={t('new_poll_option_placeholder')}
                    value={option}
                    onChange={handleChange(index)}
                  />
                  <div className="NewPoll__option__cancel" onClick={handleRemove(index)}>
                    <IcClose16 />
                  </div>
                </div>
              ))}
              {options.length < 10 && (
                <List>
                  <ListItem icon={<IcPlusCircle28 />} onClick={handleAddOption}>
                    {t('new_poll_add_option')}
                  </ListItem>
                </List>
              )}
            </div>
          </FormItem>
          {/*<FormItem />*/}
          {/*<FormItem>*/}
          {/*  <List>*/}
          {/*    <ListItem*/}
          {/*      after={<Switch checked={allowMultiple} />}*/}
          {/*      onClick={() => setAllowMultiple(!allowMultiple)}*/}
          {/*    >*/}
          {/*      Allow multiple answers*/}
          {/*    </ListItem>*/}
          {/*    <ListItem*/}
          {/*      after={<Switch checked={isAnonymous} />}*/}
          {/*      onClick={() => setAnonymous(!isAnonymous)}*/}
          {/*    >*/}
          {/*      Anonymous*/}
          {/*    </ListItem>*/}
          {/*  </List>*/}
          {/*</FormItem>*/}
        </Form>
      </ScrollView>
      <BottomBar>
        <Button stretched onClick={handleSave}>
          {t('new_poll_create')}
        </Button>
      </BottomBar>
    </>
  );
};
